import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const dsaSlice = createSlice({
  name: "dsa",
  initialState,
  reducers: {
    submitDsaForm: (state, action) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    submitDsaFormSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    submitDsaFormFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetDsaState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  submitDsaForm,
  submitDsaFormSuccess,
  submitDsaFormFailure,
  resetDsaState,
} = dsaSlice.actions;

export default dsaSlice.reducer;
